/**
 * Constants used in GDPR/legal pages.
 *
 * IMPORTANT: Fields marked with `TODO:` MUST be completed by the operator
 * (Dr. Cornelia Maria Biriș) BEFORE production deploy, based on the official
 * documents of the cabinet (Registrul Unic al Cabinetelor Medicale + document
 * fiscal CUI/CIF). The current values are placeholders and clearly marked.
 */

export const OPERATOR = {
  legalName: "Cabinet Medical Individual Dr. Cornelia Maria Biriș",
  address: "Str. General Eremia Grigorescu nr. 81, Cluj-Napoca, jud. Cluj",
  rucm: "1724.01",
  cui: "21109087",
  contactEmail: "nelibiris452@gmail.com",
  phone: "0721 592 343",
  website: "https://ro-dental.ro",
  websiteDisplay: "ro-dental.ro",
  versionDate: "1 septembrie 2026", // TODO(operator): confirmați data la momentul deploy
};
